import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import { Formik } from "formik";
import { Alert, Button, Form } from "react-bootstrap";

import useAuth from "../../hooks/useAuth";

function SignIn() {
  const navigate = useNavigate();
  const { startSignIn, isAuthenticated } = useAuth();
  const [mailSent, setMailSent] = useState<string>();
  useEffect(() => {
    if (isAuthenticated) {
      navigate("/dash");
      return;
    }
  }, [isAuthenticated, navigate]);

  return (
    <Formik
      initialValues={{
        email: "",
        submit: false,
      }}
      validationSchema={Yup.object().shape({
        email: Yup.string()
          .email("Neveljaven email naslov")
          .max(255)
          .required("Prosim vnesi email"),
      })}
      onSubmit={async (values, { setErrors, setStatus, setSubmitting }) => {
        try {
          await startSignIn(values.email);
          setMailSent(values.email);
          // navigate("/ads/list/1");
        } catch (error: any) {
          const message =
            error?.response?.data?.error ||
            error.message ||
            "Something went wrong";

          setStatus({ success: false });
          setErrors({ submit: message });
          setSubmitting(false);
        }
      }}
    >
      {({
        errors,
        handleBlur,
        handleChange,
        handleSubmit,
        isSubmitting,
        touched,
        values,
      }) => (
        <Form onSubmit={handleSubmit}>
          {!mailSent && <p className="lead">Vpiši email za nadaljevanje</p>}

          {errors.submit && (
            <Alert className="my-3" variant="danger">
              <div className="alert-message">{errors.submit}</div>
            </Alert>
          )}
          {mailSent && (
            <Alert className="my-3" variant="success">
              <div className="alert-message">
                Na vaš naslov <b>{mailSent}</b> boste prejeli povezavo za
                prijavo.
              </div>
            </Alert>
          )}

          <Form.Group className="mb-2">
            <Form.Control
              size="lg"
              type="email"
              name="email"
              className="text-center"
              autoFocus={true}
              placeholder="ime.priimek@gmail.com"
              disabled={!!mailSent}
              value={values.email}
              isInvalid={Boolean(touched.email && errors.email)}
              onBlur={handleBlur}
              onChange={handleChange}
            />
            {!!touched.email && (
              <Form.Control.Feedback type="invalid">
                {errors.email}
              </Form.Control.Feedback>
            )}
          </Form.Group>

          <div className="text-center mt-3">
            <Button
              type="submit"
              variant="primary"
              size="lg"
              disabled={isSubmitting || !!mailSent}
            >
              Prijava
            </Button>
          </div>
        </Form>
      )}
    </Formik>
  );
}

export default SignIn;
